"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _HBLinkButton = _interopRequireDefault(require("../HBLinkButton/HBLinkButton"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBTable = require("./HBTable.styles");
var _framerMotion = require("framer-motion");
var _Close = _interopRequireDefault(require("@honeybook/icons/dist/icons/Close16"));
var _HBIconButton = _interopRequireDefault(require("../HBIconButton/HBIconButton"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function HBTableFloatingBulkActions(_ref) {
  var table = _ref.table;
  var _table$options$meta = table.options.meta,
    isInitialLoading = _table$options$meta.isInitialLoading,
    bulkActions = _table$options$meta.bulkActions;
  if (!bulkActions) {
    return null;
  }
  var _table$getState = table.getState(),
    rowSelection = _table$getState.rowSelection;
  var rowSelectionCopy = _objectSpread({}, rowSelection);
  delete rowSelectionCopy.all;
  var rowIds = Object.keys(rowSelectionCopy);
  var selectedRowCount = rowSelection.all ? table.getRowCount() - rowIds.length : rowIds.length;
  var isSomeRowsSelected = rowSelection.all ? selectedRowCount < table.getRowCount() : selectedRowCount > 0;
  var isAllRowsSelected = rowSelection.all && rowIds.length === 0 || !isInitialLoading && selectedRowCount > 0 && selectedRowCount === table.getRowCount();
  var isRowsSelected = isSomeRowsSelected || isAllRowsSelected;
  return /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, null, isRowsSelected && /*#__PURE__*/_react["default"].createElement(Container, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.06,
      ease: 'easeInOut'
    }
  }, /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "body14",
    color: "textSecondary",
    ellipsis: true,
    testId: "".concat(table.options.meta.testIdPrefix, "-selection-text")
  }, isInitialLoading ? 'Loading...' : "".concat(selectedRowCount, " of ").concat(table.getRowCount(), " selected")), /*#__PURE__*/_react["default"].createElement(_HBLinkButton["default"], {
    linkButtonTheme: "neutral",
    size: "sm",
    testIdName: "select-all",
    onClick: function onClick() {
      return table.setRowSelection(isAllRowsSelected ? {} : {
        all: true
      });
    }
  }, isAllRowsSelected ? 'Deselect all' : 'Select all'), /*#__PURE__*/_react["default"].createElement(Divider, null), bulkActions.map(function (_ref2) {
    var text = _ref2.text,
      Icon = _ref2.icon,
      _onClick = _ref2.onClick;
    return /*#__PURE__*/_react["default"].createElement(_HBLinkButton["default"], {
      key: text,
      testIdName: "bulk-".concat(text),
      linkButtonTheme: "neutral",
      size: "sm",
      icon: /*#__PURE__*/_react["default"].createElement(Icon, null),
      onClick: function onClick() {
        var clearSelection = function clearSelection() {
          return table.setRowSelection({});
        };
        if (rowSelection.all) {
          _onClick({
            nin: rowIds
          }, clearSelection);
        } else {
          _onClick({
            "in": rowIds
          }, clearSelection);
        }
      }
    }, text);
  }), /*#__PURE__*/_react["default"].createElement(Divider, null), /*#__PURE__*/_react["default"].createElement(_HBIconButton["default"], {
    icon: _Close["default"],
    margin: "0 0 0 -8px",
    testIdName: "deselect-all",
    label: "Deselect all",
    onClick: function onClick() {
      return table.setRowSelection({});
    }
  })));
}
var _default = exports["default"] = HBTableFloatingBulkActions; // -------------------------- Styles -------------------------- //
var Container = (0, _styledComponents["default"])(_framerMotion.motion.div).withConfig({
  displayName: "HBTableFloatingBulkActions__Container",
  componentId: "sc-1v79xmu-0"
})(["position:sticky;align-self:center;bottom:24px;z-index:", ";width:fit-content;max-width:100%;overflow:auto;height:48px;margin:8px 0 22px;padding:0 8px 0 16px;display:flex;align-items:center;gap:16px;background-color:", ";border:1px solid ", ";border-radius:8px;box-shadow:0px 0px 10px 0px ", ",0px 14px 28px 0px ", ";"], _HBTable.TABLE_Z_INDEX.MIDDLE, _colors["default"].white, _colors["default"].neutral300, _colors["default"].blue_008, _colors["default"].blue_015);
var Divider = _styledComponents["default"].div.withConfig({
  displayName: "HBTableFloatingBulkActions__Divider",
  componentId: "sc-1v79xmu-1"
})(["width:1px;height:100%;background-color:", ";"], _colors["default"].neutral300);
//# sourceMappingURL=HBTableFloatingBulkActions.js.map